import { useEffect, useState } from 'react'

// eslint-disable-next-line @typescript-eslint/space-before-function-paren
function useDebounce<T>(value: T, delay?: number): T {
  const [debouncedValue, setDebouncedValue] = useState<T>(value)

  useEffect(() => {
    const timer = setTimeout(
      () => {
        setDebouncedValue(value)
      },
      delay != null ? delay : 500
    )

    return () => {
      clearTimeout(timer)
    }
  }, [value, delay])

  return debouncedValue
}

export default useDebounce
